import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { apiErrorInterceptor } from './core/interceptors/api-error.interceptor';
import { retryInterceptor } from './core/interceptors/retry.interceptor';
import { MessageService } from 'primeng/api';
import { LanguageService } from './core/services/language.service';
import { CurrencyService } from './core/services/currency.service';
import { TokenService } from './core/services/token.service';

const GreenTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{emerald.50}',
      100: '{emerald.100}',
      200: '{emerald.200}',
      300: '{emerald.300}',
      400: '{emerald.400}',
      500: '{emerald.500}',
      600: '{emerald.600}',
      700: '{emerald.700}',
      800: '{emerald.800}',
      900: '{emerald.900}',
      950: '{emerald.950}',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    MessageService,
    provideHttpClient(
      withFetch(),
      withInterceptors([apiErrorInterceptor, retryInterceptor, authInterceptor]),
    ),
    providePrimeNG({
      theme: { preset: GreenTheme, options: { darkModeSelector: '.dark' } },
    }),
    provideTranslateService({
      fallbackLang: 'uz',
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
    }),
    provideAppInitializer(() => inject(LanguageService).init()),
    // Valyuta sozlamasi FONDA yuklanadi — bootstrap kutmaydi.
    //
    // Ilgari bu yerda `return inject(CurrencyService).load()` turgan edi va ilova
    // so'rov tugaguncha umuman render bo'lmasdi: API sekin bo'lsa ekran oqarib
    // turardi. Endi `money` pipe'lari `pure: false`, ya'ni sozlama kelganda ekran
    // o'zi yangilanadi — kutishning hojati yo'q.
    //
    // Token bo'lmasa (login sahifasi) so'rov yuborilmaydi; kirgandan keyin
    // `AuthService.handleAuthSuccess` yuklaydi.
    provideAppInitializer(() => {
      const tokens = inject(TokenService);
      const currency = inject(CurrencyService);
      if (tokens.hasToken()) currency.load().subscribe();
      // Hech narsa QAYTARILMAYDI — bootstrap darhol davom etadi.
    }),
  ],
};
